import Resource from '@/api/resources/Resource'

class ConfigurationHealthManagementAreaServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/healthManagementAreas`, filterModel, { params })
        return response.data
    }
    async patchHealthManagementAreasBatch(healthManagementAreas) {
        const response = await this.axios.patch(`/configuration/healthManagementAreas/batch`, healthManagementAreas)
        return response.data
    }
    async createHealthManagementArea(healthManagementArea) {
        const response = await this.axios.post(`/configuration/healthManagementAreas`, healthManagementArea)
        return response.data
    }
    async deleteHealthManagementAreasBatch(healthManagementAreasIds) {
        const data = {
            entityIdentifiers: healthManagementAreasIds
        }
        const response = await this.axios.delete(`/configuration/healthManagementAreas/batch`, { data: data })
        return response.data
    }
}

export default new ConfigurationHealthManagementAreaServices()
